import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const isPrerendering = typeof window !== 'undefined' && navigator.userAgent === 'ReactSnap'

function Root() {
  const [clerk, setClerk] = useState(null);

  useEffect(() => {
    if (!PUBLISHABLE_KEY || isPrerendering) return;
    Promise.all([
      import('@clerk/clerk-react'),
      import('./components/ClerkBridge'),
    ]).then(([clerkMod, bridgeMod]) => {
      setClerk({
        Provider: clerkMod.ClerkProvider,
        Bridge: bridgeMod.default,
      });
    }).catch((err) => {
      console.warn('[Synkro] Clerk failed to load, app continues without auth:', err);
    });
  }, []);

  const app = <App />;

  if (clerk) {
    return (
      <clerk.Provider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
        <clerk.Bridge>{app}</clerk.Bridge>
      </clerk.Provider>
    );
  }

  return app;
}

const rootElement = document.getElementById('root');
const appTree = (
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

// Init Sentry after render, outside the critical path
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    import('./utils/initSentry').then(m => m.initSentry());
  }, { timeout: 3000 });
} else {
  setTimeout(() => {
    import('./utils/initSentry').then(m => m.initSentry());
  }, 2000);
}
